import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { baseUrl } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { StateService } from '../services/state.service';
import { GeneralService } from '../services/general.service';
import { jwtDecode } from "jwt-decode";

export const partnerGuard: CanActivateFn = (route, state) => {

  // Simulating an asynchronous check (e.g., an API call to validate the token)
  return new Promise<boolean>(async (resolve) => {
    const http = inject(HttpClient);
    const stateService = inject(StateService);
    const generalService = inject(GeneralService);
    const router = inject(Router);

    if (generalService.isAltomateLink()) {
      router.navigate(['/not-found']);
      resolve(false);
    }


    let currentSoftonPath = window.location.pathname
    let pathArray = currentSoftonPath.split('/')
    console.log(pathArray)

    let uuid = pathArray[pathArray[1] === 'kyc' ? 2 : 3]


    console.log(currentSoftonPath, uuid, pathArray[1] === 'kyc')

    console.log(uuid)
    http.get(`${baseUrl}/check-partner-link/${uuid}`, {}).subscribe((result) => {
      console.log(result, uuid)
      if (result['status'] === 'SUCCESS') {
        localStorage.setItem('ALTOMATEPARTNER_ACCESS_TOKEN_KEY', result['accessToken'])
        console.log(result)

        stateService.setWebsiteMetaData({
          title: result['websiteName'],
          logo: result['websiteLogo']
        })

        console.log('lol2?')
        let decodedPayload = jwtDecode(result['accessToken'])

        console.log('lol3?')

        generalService.loadingCompantDetails = true

        if (decodedPayload['applicationId']) {
          http.get(`${baseUrl}/application/${decodedPayload['applicationId']}`).subscribe((result) => {
            stateService.setCompanyDetails(result['data'] || [])
            generalService.loadingCompantDetails = false
            
          })

          
        }

        generalService.loadingUser = false
        
        console.log('lol4?')

        resolve(true)
      } else {
        router.navigate(['/not-found']);
        resolve(false);
      }
    })
  });

};
